// https://github.com/js-cookie/js-cookie
var Cookies = require('js-cookie');
// https://github.com/marcuswestin/store.js
// My custom store build : I modified the store package.json
var Store = require('store');
var Favs = require('./favourites').default;
var Searches = require('./searches').default;
var Recents = require('./recents').default;
var jquery = require('jquery');

window.Store = Store;

// Elements used by Oneall and the app
var doc_body;

var myname = 'LFPortal'
	,	endpoint = ''
	,	token
	// , sso_session_token
	, token_expiration = (1000 * 60 * 60 * 24 * 3)  // A fairly long time
	, data_expiration = (1000 * 60 * 1) // Long enough to minimise API requests
	, I18n
	, pushed_actions = []
	, triggers = {
			search: "",
			info: "",
			publicfavourites: "",
			mylucasfox: "",
	}
	, containerids = {
		// Main VUE container
		"vueapp": "",
		// One All Social login element
		"oneall": "",
	}
	, bodyclasses = {
			loggedin: "cp-logged-in",
			loggedout: "cp-logged-out",
	}
	// default Tag Manager Datalayer variable name
	, gtmdatalayername = null
	, dataset = {
			ok: false,
			tabidx: 1,
			langid: 'en',
			modal: {
				open: false,
				title: '',
				body: '',
				code: ''
			},
			publicfavourite_token: "",
			customername: "",
			customeremail: "",
			customerthumbnail: "",
			stronglylinked: false,
			favourites: [],
			searches: [],
			recents: [],
		}
;

function init(VueI18n, actions){
	// console.info('%s.init()', myname);
	endpoint = _determineEndpoint();

	// Use a reference to the main Vue localisation module
	I18n = VueI18n;
	// Store any pushed actions for running after we are fully operational
	pushed_actions = actions;
	// Pass a reference to this to Favs
	Favs.init(this);
	Searches.init(this);
	Recents.init(this);
	// Make our favs a reference to Favs.data
	dataset.favourites = Favs.data;
	dataset.searches = Searches.data;
	dataset.recents = Recents.data;
	_start();
};

function _determineEndpoint(){
	// Where should I talk to?
	var jsscript = document.getElementsByTagName("script");
  var pattern = /customerportal\.lucasfox/i;  // Try to fin scripts that match this
  var replace = /\/assets\/.*/i;
	for(var i = 0; i < jsscript.length; i++) { 
		if(pattern.test(jsscript[i].getAttribute("src"))){
			return jsscript[i].getAttribute("src").replace(replace, "/api/");
		}
	}
	return '';
}

function _start(){
	// console.info('_start');
	// TODO: Tokens expire server side 
	_getToken();

	if(!token){
		// console.log("No token");
		// No token at all
		_run_pushactions();
		_getElements()
		_showLogin();
		_clearDataset();
		return;
	}
	
	// Handle pushed actions
	_run_pushactions();
	_getElements()


	// ASSERT : We have a token
	// console.log('We have a token that we will use next request:', token);
	
	_handleSFLink();

	// Do we have any data in local storage
	// Test it for freshness by trying to access some basic customer data
	// We keep the data for long enough to survive "normal" navigation
	// If it has expired we can refresh it silently

	var newdataset = Store.get('dataset');

	if(!newdataset || _hasRefreshCookie()){
		// console.log('We have no data');
		_refreshDataset();
		return;
	}

	_hideLogin();
	// Hydrate datset from the stored data

	// Push the dataset into the data that we have shared with Vue
	dataset.customername = newdataset.customername;
	dataset.customeremail = newdataset.customeremail;
	dataset.stronglylinked = newdataset.stronglylinked;
	dataset.customerthumbnail = newdataset.customerthumbnail;
	dataset.publicfavourite_token = newdataset.publicfavourite_token;
	dataset.langid = newdataset.langid;


	dataset.ok = true;
	// console.log("We have data");
	// Tabidx is only stored on the client : We use it to keep the current tab open on navigation
	dataset.tabidx = newdataset.tabidx || 0;
	// Very important to not overwite the base array in order to keep Vue watchers
	Favs.setData(newdataset.favourites);
	Searches.setData(newdataset.searches);
	Recents.setData(newdataset.recents);
	// Push actions that need data
	_run_pushactions();
	if(gtmdatalayername){
		window[gtmdatalayername] = window[gtmdatalayername] || [];
		window[gtmdatalayername].push({"customerportaluser": true});
	}
	return;
}

function _run_pushactions(){
	// Run any pushed actions
	if(!Array.isArray(pushed_actions) || !pushed_actions.length){
		return;
	}
	// console.info('%s._run_pushactions()', myname);
	// Copy the actions we are about to run.
	// Then empty the pushed_actions array
	// When we run an action the action might push itself back in the array
	var actions = pushed_actions;
	pushed_actions = [];
	actions.forEach(function(value){
		_push(value);
	});
	// console.log("Remaining actions", pushed_actions);
}

function _push(action){
	// Some actions can run if the user is not logged in, others can't
	// console.info('_push()', action[0]);
	// Handles pushable actions.  
	// These can be queued in window.P before the Portal is fully operational
	if(!Array.isArray(action) || action.length != 2){return;}

	// Actions need to be explicitly handled
	switch(action[0]){
		case "gtmdatalayername":{
			// I expect a single name of the GTM dataLayer variable that I should push events to
			if(action[1].length){
				gtmdatalayername = action[1];
			}
			return;
		}
		case "recentlyviewed":{
			Recents.add(action[1] || '');
			if(!dataset.ok){
				pushed_actions.push(action);
			}
			return;
		}
		case "triggers":{
			// I expect a struct of trigger names and their values;
			for(var name in triggers){
				if(action[1][name] && action[1][name].length){
					triggers[name] = action[1][name];
				}
			};
			return;
		}
		case "bodyclasses":{
			// I expect a struct of class names and their values;
			for(var name in bodyclasses){
				if(action[1][name] && action[1][name].length){
					bodyclasses[name] = action[1][name];
				}
			};
			return;
		}
		case "containerids":{
			// I expect a struct of trigger names and their values;
			for(var name in containerids){
				if(action[1][name] && action[1][name].length){
					containerids[name] = action[1][name];
				}
			};
			return;
		}
		default: {
			// These actions need dataset : re-push them if dataset is not valid
			if(!dataset.ok){
				// If the dataset is not ready yet we can push this action into the array for running later
				// console.log('Dataset not ready yet');
				pushed_actions.push(action);
				return;
			}
			var fields = action[1] || {};

			switch(action[0]){
				case "fillform":{
					// I expect a struct of formfield ids to fill with customer data (if fields are empty)
					['customername','customeremail'].forEach(function(name){
						// Look for a match in the provided struct
						if(dataset[name].length && fields[name] && fields[name].length){
							// Get the form field
							var field = jquery('#'+fields[name]);
							if(field.length && !field.val().length){
								// console.log('name', name, fields[name]);
								// Fill it
								field.val(dataset[name]);
							}
						}
					});
					break;
				}
			}
		}
	}
}

function _getElements(){
	// Document body
	doc_body = document.querySelector("body");
}

function _clearDataset(){
	// console.info('%s.%s()', myname, arguments.callee.name);
	dataset.ok = false;
	dataset.customername = '';
	dataset.stronglylinked = false;
	dataset.customerthumbnail = "";
	dataset.langid = '';
	// Tabidx is only stored on the client : We use it to keep the current tab open on navigation
	dataset.tabidx = 0;
	// Very important to not overwite the base array in order to keep Vue watchers
	Favs.clearData();
	Searches.clearData();
}

function _showLogin(){
	// console.info('%s._showLogin()', myname);
	doc_body.classList.add(bodyclasses.loggedout);
	doc_body.classList.remove(bodyclasses.loggedin);
	// Show the signup promo block (Contains the Oneall signin buttons)
	_oneall.push(['social_login', 'do_render_ui', 'oa_social_login_options']);
}

function _hideLogin(){
	// console.info('_hideLogin');
	doc_body.classList.add(bodyclasses.loggedin);
	doc_body.classList.remove(bodyclasses.loggedout);
}

// Retrieves a fresh dataset from the API and stores it in local storage
function _refreshDataset(){
	// console.info('%s._refreshDataset()', myname);
	jquery.ajax({
			url:endpoint + 'dataset'
		,	method: 'GET'
		, dataType: 'JSON'
		, headers: {
			'Authorization': token
		}
	})
	.done(function(data, textStatus, jqXHR){
		// console.log("Got some data", data);
		_storeData(data);
		_start();
		// Handle existing favs cookie
		
		return;
	})
	.fail(function(xhr, status, errorThrown){
		// console.log(arguments);
		// Non-existant, invalid or expired token (Or just broken)
		// console.log(token);
		// Need to login
		_clearDataset();
		_showLogin();
		_removeTokens();
		_run_pushactions();
	});
	return;
}

function _handleSFLink(){
	// console.info('%s._handleSFLink()', myname);
	// Have we been passed a Portal_Token in a cookie?
	// These identify the SF acc
	var new_token = Cookies.get('portal_token');
	if(new_token === undefined || !new_token.length){
		return;
	}
	// console.log('Found cookie.portal_token "%s"', new_token);

	// console.info('%s.%s()', myname, arguments.callee.name);
	jquery.ajax({
				url: endpoint + 'link'
			,	method: 'POST'
			, dataType: 'JSON'
			, contentType: 'application/json; charset=utf-8'
			, headers: {'Authorization': token}
			, data: JSON.stringify({"portal_token": new_token})
		})
		.done(function(data, textStatus, jqXHR){
			// console.log("_handleSFLink.Done", data);
			// Force a logout so that we get out new link state
			// No. Just force a refresh
			_refreshDataset();
		})
		.fail(function(xhr, status, errorThrown){
			// console.error(errorThrown);
			// console.log("_handleSFLink.Fail");
		})
		.always(function(){
			// Delete the cookie now
			var res = Cookies.remove('portal_token', {path:'/', domain:document.location.hostname});
			// console.log("Removed cookie.portal_token", res);
		});
	;
}

/**
* We use a refresh cookie so that the link confirm/reject can tell us that we need to get new data
**/
function _hasRefreshCookie(){
	var new_token = Cookies.get('portal_refresh');
	if(new_token === undefined || !new_token.length){
		return false;
	}
	var res = Cookies.remove('portal_refresh', {path:'/', domain:document.location.hostname});
	// console.log("Removed cookie.portal_refresh", res);
	return true;
}

function _getToken(){
	// console.info('%s.%s()', myname, arguments.callee.name);
	// Have we been passed a portal token in a cookie?
	var new_token = Cookies.get('session_token');
	if(new_token !== undefined){
		// console.log('Found cookie.token "%s"', new_token);
		if(new_token.length){
			_storeToken(new_token);
		}
		// Delete the cookie now
		var res = Cookies.remove('session_token', {path:'/', domain:document.location.hostname});
		// console.log("Removed cookie.token", res);
		gaevent('login', '');
	}


	// Have we been passed a SSO token in a cookie?
	/*
	var new_token = Cookies.get('sso_session_token');
	if(new_token !== undefined){
		// console.log('Found cookie.sso_session_token "%s"', new_token);
		if(new_token.length){
			_storeSSO(new_token);
		}
		// Delete the cookie now
		Cookies.remove('sso_session_token', {path:'/', domain:document.location.hostname});
		// console.log("Removed cookie.sso_session_token", res);
	}
	*/

	// Try to grab an existing token
	token = Store.get('token');
	// sso_session_token = Store.get('sso_session_token');

	// console.log('token:', token);
	// console.log('sso_session_token:', sso_session_token);
	var expiration = Store.get('__storejs_expire_mixin_token');
	if(expiration !== undefined && token !== undefined){
		var exp_date = new Date(expiration);
		// console.log('Token expires at ', exp_date, Math.round((exp_date - Date.now())/1000), 'seconds');
	}
	return;
}

/*
function callback(args){
	// console.info('%s.%s()', myname, arguments.callee.name);
 	// console.log("connection_token", args.connection.connection_token);
	jquery.ajax({
				url: endpoint + 'social'
			,	method: 'POST'
			, dataType: 'json'
			, data: JSON.stringify({connection_token:args.connection.connection_token})
			, contentType: 'application/json; charset=utf-8'
		})
		.done(function(data, textStatus, jqXHR){
			// console.log("Done: %o", data);
			// Tell oneall about sso
			_oneall.push(['single_sign_on', 'do_register_sso_session', data.sso_session_token]);
			// After a fresh login I want to clear any stored data to force a refresh
			// Store token and SSO
			_storeSSO(data.sso_session_token);
			_storeToken(data.token);
			// hide the login
			_start();
			// _hideLogin();
			return;
		})
		.fail(function(xhr, status, errorThrown){
			// console.log("Fail");
			// console.dir(xhr);
			// Need to login
			_showLogin();
		})
	;		  
  // console.log (args);
  return false;
}
*/

function logout(){
	// console.info('logout()');
	// console.log(token);
	jquery.ajax({
			url:endpoint + 'social'
		,	method: 'DELETE'
		, dataType: 'JSON'
		, headers: {
			'Authorization': token
		}
		// , data: JSON.stringify({sso_session_token:sso_session_token})
		, contentType: 'application/json; charset=utf-8'
	})
	.done(function(data, textStatus, jqXHR){
		// console.log("Logged out");
	})
	.fail(function(xhr, status, errorThrown){
		// console.log(xhr.status);
		// console.log(xhr.responseJSON.message || 'no message');
	})
	.always(function(){
		// console.log('Clearing data');
		_clearDataset();
		_showLogin();
		gaevent('logout', '');
	});
	;
}

// Stores the SSO session token
/*
function _storeSSO(new_token){
	// console.info('%s.%s()', myname, arguments.callee.name);
	Store.set('sso_session_token', new_token);
}
*/

// Stores the token in both scopes
function _storeToken(new_token){
	// console.info('%s.%s()', myname, arguments.callee.name);
	var expiration = new Date().getTime() + token_expiration;  // Store token for limited time
	Store.set('token', new_token, expiration);
}

// Stores the token in both scopes
function _storeData(data){
	// console.info('%s.%s()', myname, arguments.callee.name);
	// Zip together the favourite and recents
	data.recents.forEach(function(prop){
		prop.isfav =  Favs.isFav(prop.reference);
	});
	var expiration = new Date().getTime() + data_expiration;  // Store data for limited time
	Store.set('dataset', data, expiration);
}

// Removes tokens from the store
function _removeTokens(){
	Store.remove('token');
	// Store.remove('sso_session_token');
	token = null;
	// sso_session_token = null;
}

function getData(){
	return dataset;
};

// helper for accessing VueI18n 
function $t(){
	return I18n.t.apply(I18n, arguments);
};

function gaevent(eventAction, eventLabel){
	if(!gtmdatalayername){
		return;
	}
	window[gtmdatalayername] = window[gtmdatalayername] || [];
	window[gtmdatalayername].push({
		"event": "customerportal",
		"eventAction": eventAction,
		"eventLabel": eventLabel
	});
};

export default {
	init,
	dataset,
	// callback: callback,
	logout,
	$t,
	gaevent,
	Favs,
	Searches,
	Recents,
	push: _push,
	endpoint(path){return endpoint + path;},
	langid(){return dataset.langid;},
	token(){return token;},
	save: function(){
		// console.info('%s.save()', myname);
		if(dataset.ok){
			_storeData(dataset);
		}else{
			Store.clearAll();
		}
	},
	recentlyviewed: function(ref){
		// Store the current reference somewhere handy
		Recents.add(ref);
	},
	trigger(name){
		if(triggers[name] && triggers[name].length){
			return window.location.origin + triggers[name];
		}
		return null;
	},
	containerid(name){
		return (containerids[name] || '');
	},
	containerids(){
		return containerids;
	}
};



// WEBPACK FOOTER //
// ./src/portal/portal.js